export default {
    getRoomReservations: { method: 'get', url: 'room_reservations' },
    postRoomReservations: { method: 'post', url: 'room_reservations' },
    putRoomReservations: { method: 'put', url: 'room_reservations/{id}' },
    deleteRoomReservations: { method: 'delete', url: 'room_reservations/{id}' },
    getRoomReservationConflicts: { method: 'get', url: 'room_reservations/conflicts' },
}
